import { z } from 'zod';
import { userResourceObjectValidator } from './users-resource-objects';

export const showUserResponseValidator = z.object({
    data: userResourceObjectValidator,
});

export type ShowUserResponse = z.output<typeof showUserResponseValidator>;
